var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"med-fade"}},[(_vm.tableIsOverflowing)?_c('h5',[_c('em',[_vm._v(" Hold "),_c('code',[_vm._v("shift")]),_vm._v(" and scroll to scroll sideways ")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }